<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <defs>
      <clipPath id="master_svg0_2315_16028">
        <rect x="0" y="0" width="16" height="16" rx="0" />
      </clipPath>
      <clipPath id="master_svg1_2315_15925">
        <rect x="0" y="0" width="16" height="16" rx="0" />
      </clipPath>
    </defs>
    <g clip-path="url(#master_svg0_2315_16028)">
      <g clip-path="url(#master_svg1_2315_15925)">
        <g>
          <g>
            <path
              d="M9.900000076293946,4.300000190734863L12.070000076293946,4.300000190734863L12.070000076293946,11.700000190734864L9.900000076293946,11.700000190734864L9.900000076293946,4.300000190734863ZM6.920000076293945,8.000000190734863L9.090000076293945,8.000000190734863L9.090000076293945,11.700000190734864L6.920000076293945,11.700000190734864L6.920000076293945,8.000000190734863ZM3.9200000762939453,6.480000190734863L6.100000076293945,6.480000190734863L6.100000076293945,11.700000190734864L3.930000066293945,11.700000190734864L3.9200000762939453,6.480000190734863Z"
              fill="currentColor"
            />
          </g>
          <g>
            <path
              d="M14,16L2,16C0.89543,16,0,15.1046,0,14L0,2C0,0.89543,0.89543,0,2,0L14,0C15.1046,0,16,0.89543,16,2L16,14C16,15.1046,15.1046,16,14,16ZM2,1C1.44772,1,1,1.44772,1,2L1,14C1,14.5523,1.44772,15,2,15L14,15C14.5523,15,15,14.5523,15,14L15,2C15,1.44772,14.5523,1,14,1L2,1Z"
              fill="currentColor"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'LayoutDatax2',
} as DefineComponent
</script>
